import { array } from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { database } from "../firebase";
import moment from "moment";
import "./userpost.css";
import {BounceLoader, DotLoader} from "react-spinners";
import {css} from "@emotion/react";

function getUserData(uid) {
    return new Promise((resolve, reject) => {
        return database.ref("users/" + uid).once("value", (snap) => {
            resolve(snap.val());
        });
    });
}
function UsersPost() {
    const { currentUser } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
    }));

    function getPost(uid) {
        return new Promise((resolve, reject) => {
            return database
                .ref("posts/")
                .orderByChild("uid")
                .equalTo(uid)
                .once("value", (childSnapshot) => {
                    if (childSnapshot.exists)
                        resolve(childSnapshot.val());
                });
        });
    }

    const [post, setPost] = useState([]);
    const [newfeed, setNewfeed] = useState(post);
    const [loading, setLoading] = useState(false)
    const [userpost,setuserpost]=useState([]);


    function getPosts() {
        setLoading(true)
        return database
            .ref(`/creditz`)
            .once("value")
            .then(async (snapshot) => {

                const array = [];
                snapshot.forEach((childSnapshot) => {
                    if(childSnapshot.val().uid!==currentUser.uid){

                        array.push({ data: childSnapshot.val(), key: childSnapshot.key })
                    }

                });
                var newfeed = await Promise.all(
                    array.map(async (post) => {
                        const data = await GetLikes(post.key);
                        const user = await getUserData(post.data.uid);
                        return { ...post, likedby: data, user_details: user };
                    })
                );
                newfeed.sort(function (x, y) {
                    return y.data.publishedAt - x.data.publishedAt;
                })

                setuserpost(newfeed)
                setLoading(false)

            })
    }

    function getUserData(uid) {
        return new Promise((resolve, reject) => {
            return database.ref("users/" + uid).once("value", (snap) => {
                resolve(snap.val());
            });
        });
    }

    function notifications(key) {
      userpost.map((user) => {
            return database
                .ref("Notifications/")
                .child(user.user_details?.uid).child(key)
                .set({
                    sender: currentUser.uid,
                    status: "liked",
                    credid: user.key,
                    type: 'DashCredit',
                    timestamp: moment().toDate().getTime(),
                    isDeleted: 'false',
                    isread: "false"
                });
        });

    }

    async function Like(key, uid) {
        await notifications(key);
        return database
            .ref("creditz-likes/" + key)
            .child(uid)
            .set({ uid })
            .then(() => {
                const newPost = userpost.map((x, index) => {
                    if (x.key === key) {
                        if (x.likedby == null) {
                            x.likedby = {};
                        }
                        x.likedby[uid] = { uid: uid };
                    }
                    return x;
                });
                setuserpost([...newPost]);
            })
            .catch((err) => {
            });
    }

    function GetLikes(key) {
      return new Promise((resolve, reject) => {
        return database.ref("creditz-likes/" + key).once("value", (snap) => {
            resolve(snap.val());
            });
        });
    }
    async function deleteNotification() {
      userpost.map((post) => {
            let userRef = database.ref('Notifications/' + post.user_details?.uid).child(post.key);
            userRef.remove()
        })
    }

    async function UnLike(key, uid) {
        deleteNotification();
        return database
            .ref("creditz-likes/" + key)
            .child(uid)
            .remove()
            .then(() => {
                const newPost = userpost.map((x, index) => {
                    if (x.key === key) {
                        delete x.likedby[uid];
                    }
                    return x;
                });
                setuserpost([...newPost]);
            })
            .catch((err) => {
            });
    }
    useEffect(() => {
        getPosts();
    }, []);

  const override = css`
  display: block;
  margin: 0 auto;
  border-color: purple;
  color: purple;
  opacity: 0.5;
  `;

  let [color] = useState();
    return (
        <>
            {loading==true? <DotLoader color={color} css={override} size={100} color={"#7444C0"}
                /> :
                userpost && userpost.map((post, index) => (
                    <div
                        className="card border-0 rounded-xl shadow-xs mb-3"
                        key={post.key}
                    >
                        <div
                            className="card-
            body d-flex px-4 align-items-center"
                        >
                            <div className="mmwh-45 overflow-hidden rounded-pill me-3">
                                <img
                                    src={post.user_details?.profileImageUrl}
                                    className="w-100"
                                    alt="user"
                                />
                            </div>
                           
                            <div className="me-auto">

                            <Link to =  {`profile/${post.data.uid}` } className="link"> 
                            <div className="fs-12 fw-bold capitalize">
                                    {post.user_details?.firstName} {post.user_details?.lastName}  <span id='added'>Added this Creditz</span>

                                </div>
                             </Link> 
                               
                                
                                <div className="fs-11 fw-medium text-muted">
                                    {moment(post.data.publishedAt).fromNow()}
         
                                </div>
                            </div>
                            <div className="ms-auto dropdown">
                                <button
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    className="btn mmwh-35 text-grey bg-light p-0 rounded-pill"
                                >
                                    <svg className="icon icon-3x">
                                        <use href="#icon_hdots"></use>
                                    </svg>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end border-0 rounded-xl shadow-xs">
                                    <li className="my-1">
                                        <button
                                            className="dropdown-item d-flex align-items-center"
                                            type="button"
                                        >
                                            <div className="text-muted lh-sm">
                                                <svg className="icon fs-26">
                                                    <use href="#icon_alert"></use>
                                                </svg>
                                            </div>
                                            <div className="fw-semibold ms-2">
                                                <div className="fs-12">Hide Creditz</div>
                                                <div className="text-muted fs-10">
                                                    Hide this Creditz from your feed
                                                </div>
                                            </div>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* Middle side */}
                        <div className="card-body py-0 px-4">
                            <br></br>
                            <p className="fs-12 fw-semibold text-muted lh-lg" id='track' >
                                <span id='trackname'>{post.data.trackname} </span> {" "}
                                <Link
                                    to="#"
                                    className="text-decoration-none text-primary fw-bold"
                                ></Link>
                            </p>
                            <p className="fs-12 fw-semibold text-muted lh-lg" id='artistname'>
                                <span><b>{post.data.artistname}</b> </span> {" "}
                                <Link
                                    to="#"
                                    className="text-decoration-none text-primary fw-bold"
                                ></Link>
                            </p>
                            
                            <p className="fs-12 fw-semibold text-muted lh-lg" id='role'>
                                <span><b>{post.data.role&&post.data.role}</b></span>{" "}
                                <Link
                                    to="#"
                                    className="text-decoration-none text-primary fw-bold"
                                ></Link>
                            </p>
                            <Link to =  {`viewcreditz/${post.key}`}> 
                            {post.data.albumImage != null ? (
                                <figure className="overflow-hidden rounded-lg mb-2">
                                    <img src={post.data.albumImage} className="w-100" alt="poster" />
                                </figure>
                            ) : null}
                            </Link>
                            
                        </div>
                        {/* Mottom side */}
                        <div
                            key={index}
                            className="card-body d-flex align-items-center px-4"
                        >
                            <ul className="list-inline mb-0">
                                <li className="list-inline-item me-4">
                                    {post.likedby &&
                                    Object.keys(post.likedby).includes(currentUser.uid) ? (
                                        <button
                                            type="button"
                                            className="btn d-flex align-items-center text-grey p-0"
                                            onClick={() => {
                                                UnLike(post.key, currentUser.uid);
                                            }}
                                        >
                                            <svg className="icon fs-20 me-2">
                                                <use href="#icon_heart"></use>
                                            </svg>
                                            <span className="fs-12 fw-bold">
                        {post.likedby && Object.keys(post.likedby).length} Likes
                      </span>
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn d-flex align-items-center text-grey p-0"
                                            onClick={() => {
                                                // setLiked({isLiked:true})
                                                Like(post.key, currentUser.uid);
                                            }}
                                        >
                                            <svg className="icon fs-20 me-2">
                                                <use href="#icon_heartoutline"></use>
                                            </svg>
                                            <span className="fs-12 fw-bold">
                        {post.likedby && Object.keys(post.likedby).length} Likes
                      </span>
                                        </button>
                                    )}
                               
                                </li>
                                                </ul>
                            <div className="ms-auto dropdown mb-1">
                                <button
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    className="btn d-flex align-items-center text-grey p-0"
                                >
                                    <svg className="icon icon-3x me-2">
                                        <use href="#icon_share"></use>
                                    </svg>
                                    <span className="fs-12 fw-bold">Share</span>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end border-0 rounded-xl shadow-xs">
                                    <li className="my-1">
                                        <button
                                            className="dropdown-item d-flex align-items-center"
                                            type="button"
                                        >
                                            <div className="text-muted lh-sm">
                                                {/*<svg className="icon fs-26">*/}
                                                {/*    <use href="#icon_alert"></use>*/}
                                                {/*</svg>*/}
                                            </div>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                ))}
        </>
    );
}
export default UsersPost;